<template>
  <div class="page">
    <div id="bannerName">
      <p id="name1" class="name">DANIEL</p>
      <div id="titleContainer">
        <p id="title1" class="title">Open Source Web XR Developer</p>
        <p id="title2" class="title">Web Software Developer</p>
      </div>
      <p id="name2" class="name">FERNANDES</p>
    </div>
    <div id="webgl"></div>
  </div>
</template>

<script>
import * as THREE from 'three';

export default {
  name: 'Intro',
  props: {},
  data(){
    return {
            camera: null,
            scene: null,
            renderer: null,
            shapes: [],
            cube: null,
            currentVisible: 0,
            lastVisible: 0,
            counter: 0
        }
  },
  methods: {
    initThree(){
      console.log("Three.js :)")
      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color("rgb(255,255,255)");
			this.camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );

			this.renderer = new THREE.WebGLRenderer();
      this.renderer.setSize( window.innerWidth, window.innerHeight );
      document.getElementById('webgl').appendChild( this.renderer.domElement );
      
      var geometry4 = new THREE.TorusKnotGeometry( 5, 1, 100, 16 );
      var material4 = new THREE.MeshBasicMaterial( { color: new THREE.Color("rgb(122,72,152)") } );
      var torusKnot = new THREE.Mesh( geometry4, material4 );
      torusKnot.position.x += -1;
      torusKnot.material.wireframe = true;
      torusKnot.visible = false;
      this.shapes.push(torusKnot);
      this.scene.add( torusKnot );

      var geometry3 = new THREE.TorusGeometry( 5, 1, 16, 100 );
      var material3 = new THREE.MeshBasicMaterial( { color: new THREE.Color("rgb(122,72,152)") } );
      var torus = new THREE.Mesh( geometry3, material3 );
      torus.position.x += -1;
      torus.material.wireframe = true;
      torus.visible = false;
      this.shapes.push(torus);
      this.scene.add( torus );

      var geometry2 = new THREE.SphereGeometry( 5, 32, 32 );
      var material2 = new THREE.MeshBasicMaterial( {color: new THREE.Color("rgb(122,72,152)")} );
      var sphere = new THREE.Mesh( geometry2, material2 );
      sphere.position.x += -1;
      sphere.material.wireframe = true;
      sphere.visible = false;
      this.shapes.push(sphere);
      this.scene.add( sphere );

			this.camera.position.z = 15;

			this.animate();
    },
    animate(){
      requestAnimationFrame( this.animate );
      
      if(this.counter/60 == 3){
          if(this.currentVisible == this.shapes.length-1){
            this.currentVisible = 0;
            this.lastVisible = this.shapes.length-1;
          }else{
              this.lastVisible = this.currentVisible;
              this.currentVisible++;
          }

          this.shapes[this.lastVisible].visible = false;
          this.shapes[this.currentVisible].visible = true;

          this.counter = 0;
      }

      this.shapes[this.currentVisible].rotation.x += 0.005;
      this.shapes[this.currentVisible].rotation.y += 0.005;

      this.counter++;
      
      this.renderer.render( this.scene, this.camera );
    },
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize( window.innerWidth, window.innerHeight );
    }   
  },
  created() {
    window.addEventListener( 'resize', this.onWindowResize, false );
  },
  destroyed() {
    window.removeEventListener( 'resize', this.onWindowResize, false );
  },
  mounted(){
    this.initThree();
  }
}
</script>


<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

  p{
    font-family: 'Bebas Neue', cursive;
  }
  .page{
    width: 100%;
    height: 100%;
  }
  #webgl{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0; 
      left: 0;
      filter: blur(1px);
      -webkit-filter: blur(1px);
      z-index: 0;
  }
  #bannerName{
    z-index: 2;
    text-align: center;
    border-radius: 5px;
    position: absolute;
    top: 50%;
    left: 55%;
    transform: translate(-50%, -50%);
    width: 80vw;
    display: grid;
    grid-template-columns: auto auto auto;
    grid-column-gap: 10px;
  }
  .name{
    font-size: 9vw;
    letter-spacing: 5px;
    margin: 0;
  }
  .title{
    font-size: 2vw;
  }

  @media only screen and (max-width: 600px) {
        
    }
</style>
